const sliderStyle = {
  borderRadius: "12px",
  "& .MuiSlider-track": {
    background: "#47C5FB",
    borderColor: "#47C5FB",
    height: "2px",
  },
  "& .MuiSlider-rail": {
    background: "#CCC",
    height: "2px",
  },
  "& .MuiSlider-mark": {
    display:"none"
  },
  "& .MuiSlider-thumb": {
    backgroundColor: "#47C5FB",
    width: "10px",
    height: "10px",
  },
};

export { sliderStyle };
